import { useNavigate, useParams } from 'react-router-dom';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import chatService from '../../services/chat.service';
import { ProfileExample } from '../../components/profile/ProfileExample';
import { apiMatch } from '../../api/apiMatch.api.js';
import { apiGifts } from '../../api/apiGifts.api';
import SendGiftsModal from '../../components/gifts/SendGiftsModal';
import { checkLimitError } from '../../components/limits/utils/checkLimitError.js';
import { LimitModal } from '../../components/limits/LimitModal.jsx';
import { MatchScreen } from '../MatchScreen.jsx';
import { apiUser } from '../../api/apiUser.api.js';

function NotificationSuperLikeProfile() {
  const params = useParams();
  const hasValidProfileId = Boolean(params.id && params.id !== 'undefined');
  // notificationId === 'none' — профиль открыт из участников мероприятия без симпатий:
  // показываем лайк / супер-лайк / чат (чат открывается после отправки подарка)
  const fromParticipants = params.notificationId === 'none';

  const [userData, setUserData] = useState(null);
  const [recipientData, setRecipientData] = useState(null);
  const [isOpenPresentShop, setIsOpenPresentShop] = useState(false);

  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const [showMatchesScreen, setShowMatchesScreen] = useState(false);
  const [limitsKey, setLimitsKey] = useState(null);
  const [isMatched, setIsMatched] = useState(false);
  const [isLike, setIsLike] = useState(false);

  const handleToFindOrCreateChat = async () => {
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, params.id);
      navigate(`/chats/${res.data._id}`);
    } catch (error) {
      const message = error?.response?.data?.message;
      console.error('[Profile] getChatToUserId:', error);
      toast.error(message || 'Ошибка при попытке открыть чат с пользователем');
    }
  };

  const handleLikeError = (error) => {
    const message = error?.response?.data?.message;
    const status = error?.response?.status;
    const code = error?.response?.data?.code;

    const limitKey = checkLimitError(message);

    if (status === 429 && limitKey) {
      setLimitsKey(limitKey);
      return;
    }

    if (status === 409 && code === 'ALREADY_LIKED') {
      handleToFindOrCreateChat();
      return;
    }

    toast.error(message || 'Не удалось поставить лайк');
  };

  const handleLikeOrDisLikeUser = async ({ like = true }) => {
    try {
      const res = await apiMatch.fetchLikeOrDisLike(axiosPrivate, {
        targetUserId: params.id,
        like
      });

      console.log('[LIKE RESULT]', res);

      if (!like) {
        if (params.notificationId && !fromParticipants) {
          await apiMatch.fetchDeletedNotification(axiosPrivate, {
            notificationId: params.notificationId
          });
        }

        navigate(-1);
        return;
      }

      // Лайк успешно поставлен
      setIsLike(true);
      setShowMatchesScreen(true);

      // Симпатия отработала: закрываем её уведомление, вместо него
      // появится взаимная (mutual), так что кружок у пользователя сохранится
      if (params.notificationId && !fromParticipants) {
        apiMatch
          .fetchDeletedNotification(axiosPrivate, { notificationId: params.notificationId })
          .catch((e) => console.error('[Profile] delete superlike notification:', e));
      }

      if (res?.match?.isMutual) {
        setIsMatched(true);
      }
    } catch (error) {
      console.error('[Profile] handleLikeOrDisLikeUser:', error);
      handleLikeError(error);
    }
  };

  const handleSuperLikeUser = async () => {
    try {
      const res = await apiMatch.fetchSuperLike(axiosPrivate, {
        targetUserId: params.id,
        pay: false
      });

      setIsLike(true);
      setShowMatchesScreen(true);

      // Симпатия отработала — закрываем её уведомление (взаимная уже создана)
      if (params.notificationId && !fromParticipants) {
        apiMatch
          .fetchDeletedNotification(axiosPrivate, { notificationId: params.notificationId })
          .catch((e) => console.error('[Profile] delete superlike notification:', e));
      }

      if (res?.match?.isMutual) {
        setIsMatched(true);
      }
    } catch (error) {
      console.error('[Profile] handleSuperLikeUser:', error);
      handleLikeError(error);
    }
  };

  // Чат с участником открывается только после отправки подарка
  const onSendGiftToStartChatting = async (giftId) => {
    try {
      const res = await apiGifts.sendGift(axiosPrivate, { recipientId: params.id, giftId });
      if (res.data.data.ok) {
        await handleToFindOrCreateChat();
      }
    } catch (error) {
      console.error('[Profile] Error sending gift:', error);
      toast.error(error.response?.data?.message || 'Ошибка отправки подарка');
    }
  };

  useEffect(() => {
    apiUser.fetchMe(axiosPrivate).then((res) => {
      setUserData(res.data);
    });
    apiUser.fetchUserById(axiosPrivate, params.id).then((res) => {
      try {
        setRecipientData(res);
      } catch (error) {
        const status = error?.response?.status;

        if (status === 400 || status === 404) {
          toast.error('Профиль пользователя больше недоступен');
          navigate(-1);
          return;
        }

        console.error('Error fetching user profile:', error);
      }
    });
    apiMatch.fetchHasMatch(axiosPrivate, { targetUserId: params.id }).then((res) => {
      setIsMatched(res.isMatch);
    });
  }, [params.id]);

  if (!hasValidProfileId) {
    return null;
  }

  console.log(showMatchesScreen, isLike, recipientData, userData);

  return (
    <>
      {limitsKey && <LimitModal domain="swipe" limitsKey={limitsKey} setLimitsKey={setLimitsKey} />}
      {showMatchesScreen && isLike && recipientData && userData && (
        <MatchScreen
          recipientId={params.id}
          userAPhotoUrl={userData.photos[0]}
          userBPhotoUrl={recipientData.photos[0]}
          close={() => setShowMatchesScreen(false)}
        />
      )}
      {fromParticipants && (
        <SendGiftsModal
          isOpen={isOpenPresentShop}
          onClose={() => setIsOpenPresentShop(false)}
          renderTitle={() => (
            <h2 className="text-[18px] font-semibold text-white text-center leading-[1.5] font-raleway">
              Обозначь себя, сделав человеку приятно. Это шаг к новым знакомствам!
            </h2>
          )}
          onSend={onSendGiftToStartChatting}
        />
      )}
      <ProfileExample userId={params.id} className="h-[75%] overflow-scroll rounded-[16px] !p-0" />
      <div className="flex items-center justify-center gap-4 p-4">
        {isMatched ? (
          <button
            onClick={handleToFindOrCreateChat}
            className="flex items-center justify-center gap-1 w-full rounded-full bg-[#A1F69E] text-black p-[18.5px]"
          >
            <img src="/icons/chat-bubble-typing.svg" alt="chat-bubble-typing" />
            Написать
          </button>
        ) : fromParticipants ? (
          <>
            <button
              onClick={() => handleLikeOrDisLikeUser({ like: true })}
              className="group transition-transform duration-150 active:scale-90"
              aria-label="Лайк"
            >
              <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="0.679688"
                  y="0.679688"
                  width="56.6406"
                  height="56.6406"
                  rx="28.3203"
                  fill="black"
                  fill-opacity="0.3"
                ></rect>
                <rect
                  x="0.679688"
                  y="0.679688"
                  width="56.6406"
                  height="56.6406"
                  rx="28.3203"
                  stroke="white"
                  stroke-width="1.35938"
                  class="group-hover:stroke-[#A1F69E]"
                ></rect>
                <g clip-path="url(#clip0_383_4549)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M24.3762 19.8104C25.8996 19.9208 27.4869 20.6633 29.0063 22.1662C30.5254 20.6637 32.1113 19.9226 33.6332 19.8147C35.3508 19.6928 36.8693 20.3871 37.968 21.4823C40.1279 23.6358 40.8062 27.5325 38.126 30.2128C38.117 30.2218 38.1076 30.2307 38.0982 30.2392L29.5278 38.0023C29.2318 38.2703 28.7808 38.2703 28.4848 38.0023L19.9144 30.2392C19.905 30.2307 19.8957 30.2218 19.8867 30.2128C17.1924 27.5185 17.8671 23.6214 20.0342 21.4696C21.1355 20.376 22.6569 19.6858 24.3762 19.8104Z"
                    fill="white"
                    class="group-hover:fill-[#A1F69E]"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_383_4549">
                    <rect width="21.75" height="21.75" fill="white" transform="translate(18.125 18.125)"></rect>
                  </clipPath>
                </defs>
              </svg>
            </button>
            <button
              onClick={handleSuperLikeUser}
              className="transition-transform duration-150 active:scale-90"
              aria-label="Супер лайк"
            >
              <img src="/icons/photo_overlay_button_3.svg" alt="Супер лайк" className="w-[58px] h-[58px]" />
            </button>
            <button
              onClick={() => setIsOpenPresentShop(true)}
              className="group flex items-center justify-center w-[58px] h-[58px] shrink-0 rounded-full  transition-transform duration-150 active:scale-90"
              aria-label="Чат через подарок"
            >
              <img src="/icons/photo_overlay_button_5.svg" alt="Чат через подарок" className="w-[58px] h-[58px]" />
            </button>
          </>
        ) : (
          <>
            <button onClick={() => handleLikeOrDisLikeUser({ like: false })}>
              <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="0.679688"
                  y="0.679688"
                  width="56.6406"
                  height="56.6406"
                  rx="28.3203"
                  fill="black"
                  fill-opacity="0.3"
                ></rect>
                <rect
                  x="0.679688"
                  y="0.679688"
                  width="56.6406"
                  height="56.6406"
                  rx="28.3203"
                  stroke="white"
                  stroke-width="1.35938"
                  class="group-hover:stroke-[#CE5D49]"
                ></rect>
                <g clip-path="url(#clip0_383_4539)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22.1476 20.3167C21.642 19.8111 20.8223 19.8111 20.3167 20.3167C19.8111 20.8223 19.8111 21.642 20.3167 22.1476L27.1691 29L20.3167 35.8524C19.8111 36.358 19.8111 37.1777 20.3167 37.6833C20.8223 38.1889 21.642 38.1889 22.1476 37.6833L29 30.8309L35.8524 37.6833C36.358 38.1889 37.1777 38.1889 37.6833 37.6833C38.1889 37.1777 38.1889 36.358 37.6833 35.8524L30.8309 29L37.6833 22.1476C38.1889 21.642 38.1889 20.8223 37.6833 20.3167C37.1777 19.8111 36.358 19.8111 35.8524 20.3167L29 27.1691L22.1476 20.3167Z"
                    fill="white"
                    class="group-hover:fill-[#CE5D49]"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_383_4539">
                    <rect width="18.125" height="18.125" fill="white" transform="translate(19.9375 19.9375)"></rect>
                  </clipPath>
                </defs>
              </svg>
            </button>
            <button onClick={() => handleLikeOrDisLikeUser({ like: true })}>
              <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="0.679688"
                  y="0.679688"
                  width="56.6406"
                  height="56.6406"
                  rx="28.3203"
                  fill="black"
                  fill-opacity="0.3"
                ></rect>
                <rect
                  x="0.679688"
                  y="0.679688"
                  width="56.6406"
                  height="56.6406"
                  rx="28.3203"
                  stroke="white"
                  stroke-width="1.35938"
                  class="group-hover:stroke-[#A1F69E]"
                ></rect>
                <g clip-path="url(#clip0_383_4549)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M24.3762 19.8104C25.8996 19.9208 27.4869 20.6633 29.0063 22.1662C30.5254 20.6637 32.1113 19.9226 33.6332 19.8147C35.3508 19.6928 36.8693 20.3871 37.968 21.4823C40.1279 23.6358 40.8062 27.5325 38.126 30.2128C38.117 30.2218 38.1076 30.2307 38.0982 30.2392L29.5278 38.0023C29.2318 38.2703 28.7808 38.2703 28.4848 38.0023L19.9144 30.2392C19.905 30.2307 19.8957 30.2218 19.8867 30.2128C17.1924 27.5185 17.8671 23.6214 20.0342 21.4696C21.1355 20.376 22.657 19.6858 24.3762 19.8104Z"
                    fill="white"
                    class="group-hover:fill-[#A1F69E]"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_383_4549">
                    <rect width="21.75" height="21.75" fill="white" transform="translate(18.125 18.125)"></rect>
                  </clipPath>
                </defs>
              </svg>
            </button>
          </>
        )}
      </div>
    </>
  );
}

export default NotificationSuperLikeProfile;
